import router from '@/router';
import VueAppInsights from 'vue3-application-insights';
import HttpService from '@/services/http-service';
import type { App } from 'vue';

export default async function initializeApplication(app: App<Element>): Promise<number> {
  const result = await new HttpService().httpInstance.get('config.json');

  window.$config = result.data;

  app.use(VueAppInsights, {
    id: result.data.ApplicationInsights.InstrumentationKey,
    router,
    trackInitialPageView: true,
    onLoaded: (data: any) => {
      data.addTelemetryInitializer(
        (envelope: any) => {
          envelope.data.applicationName = result.data.ApplicationInsights.ApplicationName;
          if (typeof (envelope.baseData) === 'string') {
            const name = envelope.baseData;
            envelope.baseData = {};
            envelope.baseData.name = name;
          }
        },
      );
    },
  });

  return Promise.resolve(1);
}
